import { useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useVillage() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = (subdistrict_id?: string) => {
    setLoading(true)

    api.get("/villages/", {
      params: { subdistrict_id: subdistrict_id }
    }).then((res: SuccessFetch<{
      payload: {
        village_id: string
        village_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.village_name,
          value: item.village_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, refetch }
}